import {fetchJSON} from "../../utils/dataAccess";

export function loadRequestsForSelect(valueProperty = 'id') {
  return dispatch => {
    dispatch(loading(true));
    fetchJSON('/requests?pagination=false').then((requests) => {
      dispatch(requestsLoaded(requests['hydra:member'].map(
        function (request) {
          return {
            value: request[valueProperty],
            text: request.title,
          }
        }
      )));
      dispatch(loading(false));
    }).catch(e => {
      dispatch(loading(false));
      dispatch(error(e.message));
    })
  };
}

export function loading(loading) {
  return {type: 'REQUESTS_FOR_SELECT_LOADING', loading};
}

export function error(error) {
  return {type: 'REQUESTS_FOR_SELECT_ERROR', error};
}

export function requestsLoaded(retrieved) {
  return {type: 'REQUESTS_FOR_SELECT_RETRIEVED', retrieved};
}
